import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { consultStatusColorMapping } from '../const';

const PatientCell = ({ consult }) => {
    const classes = useStyles({ status: consult.consult_status });

    return (
        <div>
            <div className={classes.statusRectangle}></div>
            <div>
                <div
                    className={classes.fullName}
                >{`${consult.patient.first_name} ${consult.patient.last_name}`}</div>
                <div className={classes.contactNumber}>{consult.patient.contact_number}</div>
            </div>
        </div>
    );
};

const useStyles = makeStyles((theme) => ({
    fullName: {
        fontSize: '14px',
        fontWeight: 600,
    },
    contactNumber: {
        fontSize: '11px',
        color: '#666666',
        lineHeight: '15px',
    },
    statusRectangle: (props) => {
        const backgroundColor = consultStatusColorMapping(theme)[props.status].main;

        return {
            width: '4px',
            height: '24px',
            position: 'absolute',
            left: 0,
            backgroundColor: backgroundColor,
        };
    },
}));

export default PatientCell;
